<style lang="less" scoped>

</style>
<template>
  <v-form
    ref="form"
    :value="true"
    style="width: 100%;"
  >
    <!-- 非hc 申请单 -->
    <v-row>
      <v-col
        cols="4"
      >
        <v-text-field
          v-model="editedItem.name"
          label="申请名称"
          required
          :rules="rules.name"
        />
      </v-col>
      <v-col
        cols="4"
      >
        <v-autocomplete 
          v-model="editedItem.team_id"
          :items="product_teams.filter(item=>!item.del)"
          item-value="id"
          :item-text="({full_name})=>full_name"
          label="执行部门"
          :rules="rules.team_id"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <DynamicForm 
          ref="dynamicForm"
          v-model="editedItem.un_hc_child_item_arr"
          :start-date="parentDetail.quarter_start_at"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="8"
      >
        <Uploader 
          v-model="editedItem.bfiles"
          :format="['image/jpeg','pdf','xls','xlsx']"
          label="申请附件"
        />
      </v-col>
      <v-col
        cols="12"
      >
        <v-textarea
          v-model="editedItem.remark"
          clearable
          rows="1"
          auto-grow
          clear-icon="mdi-close-circle"
          label="备注"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import DynamicForm from './DynamicForm'
  import Uploader from './Uploader'
  import { nonNull, decimalRule } from '../utils'
  export default {
    components: {
      Uploader,
      DynamicForm
    },
    props: {
      editedItem: {
        type: Object
      },
      positiveInteger: {
        type: Function
      },
      decimalRule: {
        type: Function
      },
      parentDetail: {
        type: Object
      }
    },
    data() {
      return {
        showDateMenu: false,
        displayHash:{
          0: false,
          1: false,
          2: false
        }
      }
    },
    methods: {
      validate() {
        const dynamicFormValidate = this.$refs.dynamicForm.validate()
        const standardValidate = this.$refs.form.validate()
        return dynamicFormValidate && standardValidate
      },
      refresh() {
        this.$refs.form.resetValidation()
        this.$refs.dynamicForm.resetValidation()
      },
      getData() { 
        const need_data = [
          'id',
          'name',
          'team_id', 
          'remark', 
          'bfiles', 
        ]
        const params = {
          is_headcount: false,
        }
        need_data.forEach(key => {
          params[key] = this.editedItem[key]
        })
        params.bfiles = (params.bfiles || []).map(item => ({
          id: item.id
        }))
        params.items = []
        const { _value: item_value } = this.editedItem.un_hc_child_item_arr
        item_value.forEach((item) => {
          if (item.is_sum || !item.title_id) {
            return
          }
          const obj = {
            title_id:item.title_id, 
            title_name: this.analysis_leaf_titles_hash[item.title_id].name
          }
          Object.keys(item).forEach(key => {
            if (['is_sum', 'title_id'].includes(key)) {
              return
            }
            if (item[key]) {
              params.items.push({
                ...obj,
                budget_amount:Number(item[key]),
                budget_month:key + '-01'
              }) 
            }
          })
        })
        return params
      }
    },
    computed: {
      ...mapGetters('async', {
        analysis_leaf_titles: 'analysis_leaf_titles', // 分析
        product_teams: 'product_teams',
        analysis_leaf_titles_hash: 'analysis_leaf_titles_hash'
      }),
      rules() {
        return {
          team_id: [
            nonNull('执行部门必选')
          ],
          name: [
            nonNull('申请名称必填')
          ],
          total_amount: [
            nonNull('申请科目金额必填'),
            decimalRule
          ],  
          headcount_type: [
            nonNull('申请HC类型必选')
          ],
          title_id: [
            nonNull('分析科目必选')
          ],
          date_check: [
            data => !!data || '请选择申请时间'
          ],
        }
      },
    },
  }
</script>